import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import CustomChip from '../Reusable/CustomChip';

const ChipDemo = () => {
  return (
    <Card className={`table-card-style`}>
      <Card.Header className="table-card-header-style">
        <Card.Title className="d-flex gap-3 align-items-center">
          Bedževi
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="mb-2">
          <Col>
            <CustomChip
              color={'success'}
              label={'nizak nivo'}
              size={'small'}
              className={'default-chip success'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'warning'}
              label={'srednji nivo'}
              size={'small'}
              className={'default-chip warning'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'error'}
              label={'visok nivo'}
              size={'small'}
              className={'default-chip error'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'info'}
              label={'info'}
              size={'small'}
              className={'default-chip info'}
            />
          </Col>
          <Col>
            <CustomChip
              label={'default'}
              size={'small'}
              className={'default-chip default'}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <CustomChip
              color={'success'}
              label={'nizak nivo'}
              className={'default-chip success'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'warning'}
              label={'srednji nivo'}
              className={'default-chip warning'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'error'}
              label={'visok nivo'}
              className={'default-chip error'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'info'}
              label={'info'}
              className={'default-chip info'}
            />
          </Col>
          <Col>
            <CustomChip label={'default'} className={'default-chip default'} />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <CustomChip
              color={'success'}
              label={'nizak nivo'}
              variant={'outlined'}
              className={'default-chip success'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'warning'}
              label={'srednji nivo'}
              variant={'outlined'}
              className={'default-chip warning'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'error'}
              label={'visok nivo'}
              variant={'outlined'}
              className={'default-chip error'}
            />
          </Col>
          <Col>
            <CustomChip
              color={'info'}
              label={'info'}
              variant={'outlined'}
              className={'default-chip info'}
            />
          </Col>
          <Col>
            <CustomChip
              label={'default'}
              variant={'outlined'}
              className={'default-chip default'}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ChipDemo;
